/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Mitarbeiter API
 * Employee master data: contact details, organisation, keys, parking and vehicles.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  Mailbox,
  MailboxInput
} from '../models';

import { customFetch } from '../../fetcher.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getListMailboxesUrl = () => {




  return `/api/mailboxes`
}

export const listMailboxes = async ( options?: Parameters<typeof customFetch>[1]): Promise<Mailbox[]> => {

  return customFetch<Mailbox[]>(getListMailboxesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMailboxesQueryKey = () => {
    return [
    `/api/mailboxes`
    ] as const;
    }


export const getListMailboxesQueryOptions = <TData = Awaited<ReturnType<typeof listMailboxes>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMailboxes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMailboxesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMailboxes>>> = ({ signal }) => listMailboxes({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMailboxes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMailboxesQueryResult = NonNullable<Awaited<ReturnType<typeof listMailboxes>>>
export type ListMailboxesQueryError = unknown


export function useListMailboxes<TData = Awaited<ReturnType<typeof listMailboxes>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMailboxes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMailboxes>>,
          TError,
          Awaited<ReturnType<typeof listMailboxes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMailboxes<TData = Awaited<ReturnType<typeof listMailboxes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMailboxes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMailboxes>>,
          TError,
          Awaited<ReturnType<typeof listMailboxes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMailboxes<TData = Awaited<ReturnType<typeof listMailboxes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMailboxes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListMailboxes<TData = Awaited<ReturnType<typeof listMailboxes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMailboxes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMailboxesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateMailboxUrl = () => {




  return `/api/mailboxes`
}

export const createMailbox = async (mailboxInput: MailboxInput, options?: Parameters<typeof customFetch>[1]): Promise<Mailbox> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<Mailbox>(getCreateMailboxUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(mailboxInput)
  }
);}





export const getCreateMailboxMutationKey = () => ['createMailbox'] as const;

export const getCreateMailboxMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMailbox>>, TError,CreateMailboxMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createMailbox>>, TError,CreateMailboxMutationVariables, TContext> => {

const mutationKey = getCreateMailboxMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMailbox>>, CreateMailboxMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createMailbox(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateMailboxMutationResult = NonNullable<Awaited<ReturnType<typeof createMailbox>>>
    export type CreateMailboxMutationBody = MailboxInput
    export type CreateMailboxMutationError = unknown
    export type CreateMailboxMutationVariables = {data: MailboxInput}

    export const useCreateMailbox = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMailbox>>, TError,CreateMailboxMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createMailbox>>,
        TError,
        CreateMailboxMutationVariables,
        TContext
      > => {
      return useMutation(getCreateMailboxMutationOptions(options), queryClient);
    }
    export const getUpdateMailboxUrl = (id: number,) => {




  return `/api/mailboxes/${id}`
}

export const updateMailbox = async (id: number,
    mailboxInput: MailboxInput, options?: Parameters<typeof customFetch>[1]): Promise<Mailbox> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<Mailbox>(getUpdateMailboxUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(mailboxInput)
  }
);}





export const getUpdateMailboxMutationKey = () => ['updateMailbox'] as const;

export const getUpdateMailboxMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMailbox>>, TError,UpdateMailboxMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateMailbox>>, TError,UpdateMailboxMutationVariables, TContext> => {

const mutationKey = getUpdateMailboxMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMailbox>>, UpdateMailboxMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateMailbox(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateMailboxMutationResult = NonNullable<Awaited<ReturnType<typeof updateMailbox>>>
    export type UpdateMailboxMutationBody = MailboxInput
    export type UpdateMailboxMutationError = unknown
    export type UpdateMailboxMutationVariables = {id: number;data: MailboxInput}

    export const useUpdateMailbox = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMailbox>>, TError,UpdateMailboxMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateMailbox>>,
        TError,
        UpdateMailboxMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateMailboxMutationOptions(options), queryClient);
    }
    export const getDeleteMailboxUrl = (id: number,) => {




  return `/api/mailboxes/${id}`
}

export const deleteMailbox = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteMailboxUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteMailboxMutationKey = () => ['deleteMailbox'] as const;

export const getDeleteMailboxMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMailbox>>, TError,DeleteMailboxMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteMailbox>>, TError,DeleteMailboxMutationVariables, TContext> => {

const mutationKey = getDeleteMailboxMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMailbox>>, DeleteMailboxMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteMailbox(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteMailboxMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMailbox>>>

    export type DeleteMailboxMutationError = unknown
    export type DeleteMailboxMutationVariables = {id: number}

    export const useDeleteMailbox = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMailbox>>, TError,DeleteMailboxMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteMailbox>>,
        TError,
        DeleteMailboxMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteMailboxMutationOptions(options), queryClient);
    }
